import React from 'react';

const Timer = ({ displayTime, seconds }) => {
  const totalSeconds = displayTime;
  const timeLeft = Math.max(totalSeconds - seconds, 0);

  const formatTime = (secs) => {
    const mins = Math.floor(secs / 60).toString().padStart(2, '0');
    const s = (secs % 60).toString().padStart(2, '0');
    return { mins, secs: s };
  };

  const { mins, secs: secStr } = formatTime(timeLeft);
  const percentage = (seconds / totalSeconds) * 100;

  return (
    <div className="timer-container">
      <div className="timer-text">
        <span className="timer-digits">{mins}</span>
        <span className="timer-colon">:</span>
        <span className="timer-digits">{secStr}</span>
      </div>
      {/* <div className="timer-labels">
        <span>Minutes</span>
        <span>Seconds</span>
      </div>
      <div className="timer-progress-wrapper">
        <div className="timer-progress" style={{ width: `${percentage}%` }} />
      </div> */}
    </div>
  );
};

export default Timer;
